<!--
 * @Autor: 
 * @Description: 商品卡片
 * @Date: 2021-07-15 15:37:36
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: 2021-07-28 18:51:28
-->
<template>
  <div class="good-card" :class="{'js': index % 2 == 1}" @click="toDetail">
    <div class="img-box">
      <img :src="itemData.categoryTabItemImg" class="item-img">
      <!-- 新品而且是全网爆款才显示这个标 -->
      <img class="new-good-tag" v-if="goodType === 2 && itemData.saleBillionPlus" src="https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/hot-good.png" />
      <div class="no-stock" v-if="goodType === 2 && itemData.stock === 0">
        <img src="https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/no-stock.png" />
      </div>
    </div>
    <div class="item-container">
      <div class="item-name" 
        :class="{
          'text-x': itemData.itemName,
          'not-recommend': !itemData.itemName
        }"
      >
        {{itemData.recommend}}
      </div>
      <div class="item-sub-title text-x">{{itemData.itemName}}</div>
      <!-- <div class="tag-list">
        <span v-for="(item, index) in itemData.markArray" :key="index" v-show="item.type !== 7 && item.type !== 6">
          <img class="label-img" :src="item.img" v-if="item.type == 11 && item.img" >
          <span 
            v-else
            class="tag-style text-x"
            :class="`tag-style-${item.type}`"
            :style='{"color":item.colour}'
            >
            {{item.name}}
          </span>
        </span>
      </div> -->
      <div class="mark-wrap">
        <markText :showAtmosphere="true" :markList="itemData.markArray"></markText>
      </div>
      <div class="price-box">
        <span class="price-value">￥{{itemData.itemPrice}}</span>
        <span v-if="!showCommission" class="price-vip">￥{{itemData.itemVipPrice}}</span>
        <span v-if="showCommission" class="price-get">赚{{itemData.minCommission}}</span>
      </div>
    </div>
    <img class="share-btn" v-if="isApp" src="https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/big-share-btn-1.png" @click.stop="shareHandle"/>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import YunJi from '@/assets/js/YunJi'
import markText from '@/pages/commodity/components/Marking'

const { mapState } = createNamespacedHelpers('categoryNav')

export default {
  name: 'good-card',
  components: {
    markText
  },
  props: {
    itemData: {
      type: Object
    },
    index: {
      type: Number
    },
    goodType: {
      type: Number,
      defualt: 1 // 1普通商品 2新品
    }
  },
  data() {
    return {
      appCont: Number(YunJi.getUrlParams('appCont') || 0)
    }
  },
  computed: {
    ...mapState(['userType', 'isApp', 'isSharing']),
    // tag过滤石榴节标签，并且只显示2个
    tagList() {
      let arr = []
      if (this.goodType === 2) {
        arr.push({ type: 2, text: '新品' })
        if (this.itemData.sellPointTxt) arr.push({ type: 8, text: this.itemData.sellPointTxt })
        return arr
      } 
      arr = this.itemData.itemMarkModels || []
      arr = arr.filter(item => item.type !== 6)
      return arr.slice(0, 2)
    },
    // 是否在预热期
    isInWarmUp() {
      const currentTime = new Date().getTime()
      return currentTime < this.itemData.startTime
    },
    showCommission() {
      return (this.appCont == 1 && !this.isSharing) || (this.appCont == 7 && this.userType == 1)
    }
  },
  methods: {
    toDetail() {
      this.$emit('toDetail', {
        index: this.index,
        clickType: '普通新品',
        jumpType: 2, // 0无跳转 1专题 2商品 3网址 4品牌团 5直播 6主播 7榜单 8店铺编码
        jumpValue: this.itemData.itemId,
        goodType: this.goodType
      })
    },
    shareHandle() {
      const params = {
        shareImg: this.itemData.itemImgBig,
        title: this.itemData.itemName,
        itemId: this.itemData.itemId,
        shareLink: `${window.location.protocol}//${window.location.hostname}/yjbuyer`,
        shareBigImg: this.itemData.itemImgBig,
        commission: this.itemData.minCommission,
        price: this.itemData.itemPrice,
        subTitle: this.itemData.recommend
      }
      // 需要编码的字段
      const needEncode = ['subTitle', 'title']
      let paramsStr = ''
      let value = ''
      for (const key of Object.keys(params)) {
        value = needEncode.indexOf(key) >= 0 ? encodeURIComponent(params[key]) : params[key]
        paramsStr += `${key}=${value}&`
      }
      console.log(paramsStr)
      window.location.href = `yunji://itemShare?${paramsStr}`
    }
  }
}
</script>
<style lang="less" scoped>
.good-card:before{
  border: 1px solid #E6E6E6;
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  border-radius: .08rem;
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scale(0.5, 0.5);
  -ms-transform: scale(0.5, 0.5);
  -o-transform: scale(0.5, 0.5);
  transform: scale(0.5, 0.5);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.img-box:before {
  border: 1px solid #E6E6E6;
  border-bottom: 0;
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  border-radius: .08rem;
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scale(0.5, 0.5);
  -ms-transform: scale(0.5, 0.5);
  -o-transform: scale(0.5, 0.5);
  transform: scale(0.5, 0.5);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.good-card {
  width: 2.5rem;
  height: 4.4rem;
  position: relative;
  &.js{
    margin-left: .14rem !important;
  }
  .img-box {
    box-sizing: border-box;
    height: 2.5rem;
    position: relative;
    border-radius: .07rem .07rem 0 0;
    .item-img {
      width: 100%;
      height: 100%;
      border-radius: .07rem .07rem 0 0;
      box-sizing: border-box;
      background-color: #FCFCFC;
    }
    .no-stock {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0,0,0,0.20);
      box-sizing: border-box;
      border-radius: .08rem .08rem 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 1.02rem;
        height: 1.02rem;
      }
    }
    .new-good-tag {
      width: .98rem;
      height: .32rem;
      position: absolute;
      left: .08rem;
      bottom: .08rem;
    }
    .bottom-tag {
      opacity: 0.6;
      background-color: #000000;
      font-family: PingFangSC-Regular;
      font-size: .24rem;
      color: #FFFFFF;
      text-align: center;
      line-height: .32rem;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
  .item-container {
    padding: .08rem 0 0 .12rem;
    border-radius: 0 0 .07rem .07rem;
  }
  .item-name {
    font-family: PingFangSC-Regular;
    font-size: .26rem;
    color: #262626;
    margin-bottom: .01rem;
    padding-right: .12rem;
  }
  .item-sub-title {
    font-family: PingFangSC-Regular;
    font-size: .24rem;
    margin-bottom: .06rem;
    margin-left: -0.07rem;
    color: #999999;
    padding-right: .12rem;
    transform: scale(.95);
    text-size-adjust: none;
  }
  .not-recommend {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .tag-list {
    overflow: hidden;
    max-height: .36rem;
    margin-bottom: .14rem;
    min-height: .36rem;
    margin-left: -.02rem;
  }
  .tag-style {
    border-radius: .04rem;
    font-size: .24rem;
    display: inline-block;
    transform: scale(.9);
    text-size-adjust: none;
    padding: 0 .06rem;
    line-height: .36rem;
    max-width: 2.35rem;
  }
  .label-img{
    display: inline-block;
    height: .3rem;
    background-size: 100% 100%;
    vertical-align: initial;
    margin-right: .08rem;
    position: relative;
    top: -1px;
  }
  .tag-style:nth-child(n + 2) {
    margin-left: -.05rem
  }
  .tag-style-2 {
    font-family: PingFangSC-Regular;
    background: #FF2735;
    color: #FFFFFF;
    
  }
  .tag-style-8 {
    background: rgba(238,37,50,0.10);
    color: #EE2532;
  }
  .price-box {
    position: absolute;
    left: .1rem;
    bottom: .18rem;
    .price-value {
      font-family: PingFangSC-Medium;
      font-size: .26rem;
      color: #111111;
      margin-right: .04rem;
    }
    .price-get {
      font-family: PingFangSC-Regular;
      font-size: .2rem;
      color: #FF2735;
      text-size-adjust: none;
      display: inline-block;
      transform: translateY(-1px);
    }
    .price-vip {
      font-family: PingFangSC-Regular;
      font-size: .24rem;
      color: #999999;
      transform: scale(.8);
      text-size-adjust: none;
      display: inline-block;
      text-decoration:line-through;
    }
  }
  .text-x {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .share-btn {
    position: absolute;
    bottom: .14rem;
    right: .08rem;
    width: .46rem;
    height: .46rem;
  }
  .mark-wrap {
    position: relative;
  }
}
</style>
